import { get } from "lodash";

export const getComposerMessageToQuoteId = (state, { chatId }) =>
  get(state, ["chat", "composer", chatId, "messageToQuoteId"]);
